import React, { Component } from 'react';
import _ from 'lodash';
import {
    getPayoutRecipients as fetchPayoutRecipients,
    fetchUrl,
    selectRecipient
} from './payoutRecipientsActions';
import {
    getPayoutRecipients,
    getCount,
    getPages,
    getPayoutRecipientsErrorMessage,
    getIsPayoutRecipientsLoading,
    getHasMore
} from './payoutRecipientsEntity';
import PayoutRecipientsListItem from './PayoutRecipientsListItem/PayoutRecipientsListItem';
import Table from '../Table/Table';
import {
    dataTransform,
    payoutProviderMapper
} from '@nexio/emvio-util-app';
import PropTypes from 'prop-types';
import { getSelectedPayoutAccountIdsString } from '../PayoutAccountSelector/payoutAccountSelectorViewState';
import { getPayoutAccountsMapper } from '../PayoutAccounts/payoutAccountEntity';
import { getColumnsByUniqueTableName } from '../Table/tableEntity';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import './PayoutRecipients.scss';
import FilterWithMapper from '../Table/Filters/FilterWithMapper/FilterWithMapper';
import { transformDateCellNoTimeZone, transformDateTimeCell } from '../../utils/cell';

export class PayoutRecipients extends Component {
    dateKey = 'updatedAt';

    static propTypes = {
        selectedPayoutAccountIds: PropTypes.string,
        columns: PropTypes.array,
        payoutAccountMap: PropTypes.any
    };

    constructor(props) {
        super(props);

        this.state = {};

        this.defaultColumnsAndProps = [
            {
                accessor: 'recipientRef',
                className: ['cursor-pointer'],
                label: 'Recipient Reference',
                minWidth: 150,
                show: true,
                sortable: false
            },
            {
                accessor: 'firstName',
                className: ['cursor-pointer'],
                label: 'First Name',
                minWidth: 120,
                show: true,
                sortable: false
            },
            {
                accessor: 'lastName',
                className: ['cursor-pointer'],
                label: 'Last Name',
                minWidth: 120,
                show: true,
                sortable: false
            },
            {
                accessor: 'email',
                className: ['cursor-pointer'],
                label: 'Email',
                minWidth: 175,
                show: true,
                sortable: false
            },
            {
                label: 'Payout Provider',
                accessor: 'providerType',
                transformData: dataTransform.payoutProviderMapper,
                Filter: ({ filter, onChange }) => (
                    <FilterWithMapper
                        filter={filter}
                        mapper={payoutProviderMapper}
                        onChange={onChange}
                    />
                ),
                filterable: true,
                className: ['cursor-pointer'],
                minWidth: 160,
                show: true,
                sortable: false
            },
            {
                accessor: 'recipientId',
                className: ['cursor-pointer'],
                label: 'Recipient Id',
                minWidth: 140,
                show: true,
                sortable: false
            },
            {
                accessor: 'country',
                className: ['cursor-pointer'],
                label: 'Country',
                minWidth: 110,
                show: true,
                sortable: true,
                filterable: true
            },
            {
                accessor: 'createdAt',
                Cell: transformDateCellNoTimeZone,
                className: ['cursor-pointer'],
                defaultSortDesc: true,
                filterable: false,
                label: 'Created Date',
                minWidth: 140,
                show: true
            },
            {
                accessor: 'updatedAt',
                Cell: transformDateTimeCell,
                className: ['cursor-pointer'],
                defaultSortDesc: true,
                filterable: false,
                label: 'Updated Date',
                minWidth: 200,
                show: true
            },
            {
                accessor: 'payoutAccountId',
                transformData: (data) => `${data.original.payoutAccountId} - ${this.props.payoutAccountMap[data.original.payoutAccountId]}`,
                filterable: true,
                Filter: ({ filter, onChange }) => (
                    <FilterWithMapper filter={filter}
                        mapper={this.getPayoutAccountsDropDown()}
                        onChange={onChange}
                    />
                ),
                className: ['cursor-pointer'],
                label: 'Payout Account',
                minWidth: 200,
                show: true,
                sortable: true
            }
        ];
    }

    getTableState = (tableState) => {
        this.setState({
            ...tableState
        });
    };

    getPayoutAccountsDropDown = () => {
        const result = {};
        _.forEach(this.props.payoutAccountMap, (value, key) => {
            result[key] = `${key} - ${value}`;
        });

        return result;
    };

    render() {
        return (
            <div className="emvio-payout-recipients">
                <Table
                    fetchUrl={fetchUrl}
                    className="emvio-payout-recipients-table"
                    dateKey={this.dateKey}
                    defaultColumnsAndProps={this.defaultColumnsAndProps}
                    defaultSorted={[{
                        desc: true,
                        id: this.dateKey
                    }]}
                    fetchData={(filters, page, pageSize, sorters, merchantIds, columns) => fetchPayoutRecipients(filters, page, pageSize, sorters, this.props.selectedPayoutAccountIds, columns)}
                    countSelector={getCount}
                    dataSelector={getPayoutRecipients}
                    errorMessageSelector={getPayoutRecipientsErrorMessage}
                    isDataLoadingSelector={getIsPayoutRecipientsLoading}
                    pagesSelector={getPages}
                    selectRow={selectRecipient}
                    itemKey="recipientId"
                    hasNoCount={true}
                    ListItemComponent={PayoutRecipientsListItem}
                    noDataText="No Recipients Found"
                    uniqueTableName="PayoutRecipients"
                    getTableState={this.getTableState}
                    hasMoreSelector={getHasMore}
                    filterable={true}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedPayoutAccountIds: getSelectedPayoutAccountIdsString(state),
        columns: getColumnsByUniqueTableName(state, 'PayoutRecipients'),
        payoutAccountMap: getPayoutAccountsMapper(state)
    };
}

export default withRouter(connect(mapStateToProps)(PayoutRecipients));
